module.exports = "/_next/static/images/ec59499177847e6f3d3d014599d7d6a4-hero-desktop.jpg.webp";